<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import LoadingHandler from '@/layout/loading/LoadingHandler.vue'
import { productBus } from '@/event/product/productBus'
import { messageAlertSelectProductHappy } from '@/happyTheme/event/product/messageAlertSelectProductHappy'
import ModalProductHappy from '@/happyTheme/components/product/ModalProductHappy.vue'
import MessageAlertSelectedProductHappy from '@/happyTheme/components/product/alert/MessageAlertSelectedProductHappy.vue'
import ModalBasketHappy from '@/happyTheme/components/layout/modal/modalBasket/ModalBasketHappy.vue'
import { showModalBasketHappy } from '@/happyTheme/event/modalBasket/showModalBasketHappy'
import { messageLogin } from '@/event/account/alert/messageLogin'
import ModalMessageAlertLoginHappy from '@/happyTheme/components/account/login/alert/ModalMessageAlertLoginHappy.vue'
import ModalMessageAlertRegisterHappy from '@/happyTheme/components/account/register/alert/ModalMessageAlertRegisterHappy.vue'
import { messageRegister } from '@/event/account/alert/messageRegister'
import MessageAlertDisconnectHappy from '@/happyTheme/components/account/disconnect/MessageAlertDisconnectHappy.vue'
import { messageAlertDisconnectHappy } from '@/happyTheme/event/messageDisconnect/messageAlertDisconnectHappy'
import AlertMessageDashboardHappy from '@/happyTheme/components/account/alert/AlertMessageDashboardHappy.vue'
import { alertMessageHappy } from '@/happyTheme/event/dashboard/alert/AlertMessageHappy'
import AlertDeleteAddressHappy from '@/happyTheme/components/account/alert/AlertDeleteAddressHappy.vue'
import { alertMessageDeleteAddressHappy } from '@/happyTheme/event/dashboard/address/alertMessageDeleteAddressHappy'
import ModalAddressHappy from '@/happyTheme/components/account/dashboard/address/ModalAddressHappy.vue'
import { showModalAddressHappy } from '@/happyTheme/event/dashboard/address/showModalAddressHappy'
import ModalShowOrderHappy from '@/happyTheme/components/account/dashboard/order/ModalShowOrderHappy.vue'
import { selectedOrder } from '@/event/account/dashboard/history/selectedOrder'
import ModalDeliveryZonesHappy from '@/happyTheme/components/order/option/ModalDeliveryZonesHappy.vue'
import { showDeliveryZones } from '@/event/order/showDeliveryZones'
import AlertDeleteCustomerHappy from '@/happyTheme/components/account/alert/AlertDeleteCustomerHappy.vue'
import { requestDeleteCustomer } from '@/happyTheme/event/dashboard/user/requestDeleteCustomer'
import { showPrivacyPolicyModalBus } from '@/event/main/information/showPrivacyPolicyModalBus'
import { showConditionUseModalBus } from '@/event/main/information/showConditionUseModalBus'
import { isThemeIfoFamily } from '@/event/theme/theme'

// refactored — EmberEffectIfo geri döndü: body solid bg-t-bg + ember canvas
// z-index: 1 (üstte). Olive glow yok çünkü body transparent değil — canvas
// body'nin üstünde dots olarak çiziliyor, footer üzerinde de görünüyor.
// pointer-events: none ile tıklama engellenmiyor.

const EmberEffectIfo = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/EmberEffectIfo.vue')
)
const HeaderHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/header/HeaderHappy.vue')
)
const FooterHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/FooterHappy.vue')
)
</script>

<template>
    <section class="w-full min-h-screen flex flex-col justify-between relative">
        <div class="w-full flex flex-col items-center">
            <section class="w-full">
                <HeaderHappy />
                <div class="h-[96px]"></div>
            </section>

            <ModalProductHappy v-if="productBus" />
            <ModalBasketHappy v-if="showModalBasketHappy" />

            <ModalMessageAlertLoginHappy v-if="messageLogin.class" />
            <ModalMessageAlertRegisterHappy v-if="messageRegister.class" />
            <MessageAlertDisconnectHappy v-if="messageAlertDisconnectHappy.class" />

            <ModalShowOrderHappy v-if="selectedOrder !== undefined" />

            <ModalAddressHappy v-if="showModalAddressHappy" />
            <AlertDeleteAddressHappy v-if="alertMessageDeleteAddressHappy.class" />

            <AlertMessageDashboardHappy v-if="alertMessageHappy.class" />
            <AlertDeleteCustomerHappy v-if="requestDeleteCustomer" />

            <section
                v-if="showPrivacyPolicyModalBus"
                class="section-overlay-happy"
                @click="showPrivacyPolicyModalBus = false"
            ></section>

            <section
                v-if="showConditionUseModalBus"
                class="section-overlay-happy"
                @click="showConditionUseModalBus = false"
            ></section>

            <MessageAlertSelectedProductHappy
                :option="messageAlertSelectProductHappy.option"
                :type="messageAlertSelectProductHappy.type"
                :message="messageAlertSelectProductHappy.message"
                :title="messageAlertSelectProductHappy.title"
            />

            <ModalDeliveryZonesHappy v-if="showDeliveryZones" />

            <LoadingHandler />
        </div>
        <FooterHappy />
        <EmberEffectIfo v-if="isThemeIfoFamily" />
    </section>
</template>

<style scoped>
.section-overlay-happy {
    @apply w-full h-full fixed top-0 left-0 opacity-50 z-30 flex items-center justify-center;
    @apply bg-text-dark-happy-light;
    @apply happy-light:bg-text-dark-happy-light;
    @apply happy-dark:bg-bg-happy-light;
    @apply happy-gray-sand:bg-text-dark-happy-light;
}
</style>
